import React, {useEffect} from 'react';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {ArrowDropDown} from "@mui/icons-material";
import {
    eventStatus, eventStatusColor, eventStatusLabel
} from "../../util/standards-util";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {useDispatch, useSelector} from "react-redux";
import {isSgpAdmin} from "../../hooks/useUserRole";
import {useUpdateEventSetupMutation} from "../../slices/apiSlice";
import {setEvent, setEventRules} from "../../slices/sessionSlice";


const statusOptions = {
    admin: {
        planned:[40,90],
        active:[20],
        completed:[10],
        scheduled:[30,90],
        cancelled:[40],
    },
    manager: {
        planned:[],
        active:[20],
        completed:[10],
        scheduled:[],
        cancelled:[],
    },
}

const getStatusOptions = (status, isAdmin) => {
    const role = isAdmin ? 'admin' : 'manager'
    switch(status) {
        case eventStatus.STATUS_PLANNED:
        case eventStatus.STATUS_PLANNED_REGISTRATION_CLOSED:
            return statusOptions[role].planned
        case eventStatus.STATUS_COMPLETED:
            return statusOptions[role].completed
        case eventStatus.STATUS_ACTIVE:
            return statusOptions[role].active
        case eventStatus.STATUS_SCHEDULED:
            return statusOptions[role].scheduled
        case eventStatus.STATUS_CANCELLED:
            return statusOptions[role].cancelled
        default:
            return []
    }
}


const EventStatusWidget = ({onUpdate = () => {} }) => {

    const dispatch = useDispatch()
    const session = useSelector(state => state.session)
    const event = session.event
    const [options, setOptions] = React.useState([]);
    const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
    const menuOpen = Boolean(menuAnchorEl);


    const [update, updateResult] =
        useUpdateEventSetupMutation()

    const handleMenuClose = (e) => {
        setMenuAnchorEl(null);
    }

    const handleChangeStatus = (e, u) => {
        handleMenuClose(e)

        update({
            id: event.id,
            status: u,
        })
    }

    const handleClicked = (e) => {
        e.stopPropagation()
        if (options.length>0)  setMenuAnchorEl(e.currentTarget);
    }

    useEffect(() => {
        setOptions(getStatusOptions(event.status,isSgpAdmin(session)))
    }, []);

    useEffect(() => {
        setOptions(getStatusOptions(event.status,isSgpAdmin(session)))
    }, [event]);

    useEffect(() => {
        if (updateResult.isSuccess){
            if (updateResult.data.status === "ok") {
                dispatch(setEvent(updateResult.data.event))
                dispatch(setEventRules(updateResult.data.rules))
                onUpdate(updateResult.data)
            }
        }
    }, [updateResult]);


    return (
        <Box sx={{display:'flex',alignItems:'center'}}>
            <Typography variant={'body1'} mr={1}>Status:</Typography>
            <Button
                variant={'contained'}
                endIcon={options.length>0 ? <ArrowDropDown/> : ''}
                color={eventStatusColor[event.status]}
                size={'small'}
                onClick={handleClicked}
            >
                {eventStatusLabel[event.status]}
            </Button>
            <Menu
                anchorEl={menuAnchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={menuOpen}
                onClose={handleMenuClose}
            >
                {options.map(u=>{
                    return <MenuItem key={u} onClick={(e)=>{handleChangeStatus(e,u)}}>
                        {eventStatusLabel[u]}
                    </MenuItem>
                })}
            </Menu>
        </Box>
    )
}

export default EventStatusWidget;